/* 25-10: het fotovak op de productpagina volgt de foto die in beeld is. De slides hebben
   verschillende verhoudingen; zonder dit pakt het vak de langste en staat er wit onder een
   kortere. Tijdens het swipen loopt de hoogte mee tussen de twee foto's in beeld. */
(function(){
  var s=document.getElementById('pslides'); if(!s) return;
  var k=s.querySelectorAll('.slide'); if(!k.length) return;
  var raf=0;
  function h(el){return el.getBoundingClientRect().height;}
  function fit(){
    raf=0; var w=s.clientWidth; if(!w) return;
    var p=s.scrollLeft/w, i=Math.max(0,Math.min(Math.floor(p),k.length-1)), j=Math.min(i+1,k.length-1);
    var a=h(k[i]), b=h(k[j]) || a; if(!a) return;
    s.style.setProperty('height',Math.round(a+(b-a)*(p-i))+'px','important');
  }
  function vraag(){ if(!raf) raf=requestAnimationFrame(fit); }
  s.addEventListener('scroll',vraag,{passive:true});
  s.addEventListener('load',vraag,true);
  addEventListener('resize',vraag);
  vraag();
})();
